import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { API_BASE } from '../config/api';

function Actualites() {
  const { i18n } = useTranslation();
  const [articles, setArticles] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/api/articles`)
      .then(res => { if (!res.ok) throw new Error(); return res.json(); })
      .then(data => { setArticles(data); setLoading(false); })
      .catch(() => {
        // Fallback to static import if API unavailable
        import('../data/articles.json').then(m => {
          setArticles(m.default);
          setLoading(false);
        });
      });
  }, []);

  // Get unique categories
  const categories = ['all', ...new Set(articles.map(article => article.category))];

  // Filter articles by category
  const filteredArticles = selectedCategory === 'all'
    ? articles
    : articles.filter(article => article.category === selectedCategory);

  if (loading) {
    return (
      <article className="page type-page status-publish hentry">
        <header className="entry-header">
          <h1 className="entry-title">Actualités</h1>
        </header>
        <div className="entry-content">
          <p>Chargement des articles...</p>
        </div>
      </article>
    );
  }

  return (
    <article className="page type-page status-publish hentry">
      <header className="entry-header">
        <h1 className="entry-title">Actualités</h1>
      </header>

      <div className="entry-content">
        <p>Retrouvez ici toutes les actualités de l'association RIVE.</p>

        {/* Category filter */}
        <div style={{ marginBottom: '30px' }}>
          <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Filtrer par catégorie :</label>
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              style={{
                margin: '5px',
                padding: '8px 15px',
                backgroundColor: selectedCategory === cat ? '#32afe5' : '#f0f0f0',
                color: selectedCategory === cat ? 'white' : '#333',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                textTransform: 'capitalize'
              }}
            >
              {cat === 'all' ? 'Toutes' : cat}
            </button>
          ))}
        </div>

        {/* Articles grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: '30px',
          marginTop: '20px'
        }}>
          {filteredArticles.map(article => {
            const lang = i18n.language;
            const t = (lang && lang !== 'fr' && article.translations?.[lang]) || {};
            const title = t.title || article.title;
            const excerpt = t.excerpt || article.excerpt;

            return (
            <div key={article.id} style={{
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              overflow: 'hidden',
              transition: 'box-shadow 0.3s ease',
              backgroundColor: 'white'
            }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
            >
              {article.featuredImage && (
                <Link to={`/actualites/${article.slug}`}>
                  <img
                    src={article.featuredImage}
                    alt={title}
                    style={{
                      width: '100%',
                      height: '200px',
                      objectFit: 'cover'
                    }}
                  />
                </Link>
              )}

              <div style={{ padding: '20px' }}>
                <div style={{
                  fontSize: '12px',
                  color: '#32afe5',
                  textTransform: 'uppercase',
                  marginBottom: '10px',
                  fontWeight: 'bold'
                }}>
                  {article.category}
                </div>

                <h2 style={{
                  fontSize: '20px',
                  marginBottom: '10px',
                  lineHeight: '1.4'
                }}>
                  <Link
                    to={`/actualites/${article.slug}`}
                    style={{
                      color: '#333',
                      textDecoration: 'none'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#32afe5'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#333'}
                  >
                    {title}
                  </Link>
                </h2>

                {article.date && (
                  <div style={{
                    fontSize: '14px',
                    color: '#888',
                    marginBottom: '15px'
                  }}>
                    {new Date(article.date).toLocaleDateString('fr-FR', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </div>
                )}

                <p style={{
                  fontSize: '15px',
                  lineHeight: '1.6',
                  color: '#666',
                  marginBottom: '15px'
                }}>
                  {excerpt}
                </p>

                <Link
                  to={`/actualites/${article.slug}`}
                  style={{
                    color: '#32afe5',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                  onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                >
                  Lire la suite →
                </Link>
              </div>
            </div>
            );
          })}
        </div>

        {filteredArticles.length === 0 && (
          <p style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
            Aucun article trouvé dans cette catégorie.
          </p>
        )}
      </div>
    </article>
  );
}

export default Actualites;
